import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Login.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email) {
      setError('Please enter your email address.');
      return;
    }
    setError('');
    setMessage('');

    fetch('/forgot-password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email })
    })
      .then(res => res.json())
      .then(data => {
        setSubmitted(true);
        setMessage(data.message);
      })
      .catch(() => {
        setError('An error occurred. Please try again.');
      });
  };

  return (
    <div className="auth-container">
      <form className="auth-form" onSubmit={handleSubmit}>
        <div className="auth-header">
          <p>Account recovery</p>
          <h1>Reset your password</h1>
        </div>
        {error && <div className="error-message">{error}</div>}
        {message && <div className="success-message">{message}</div>}
        {!submitted ? (
          <>
            <p className="auth-description">
              Enter the email address associated with your account and we'll send you a link to reset your password.
            </p>
            <label>Email
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
              />
            </label>
            <button type="submit">Send reset link</button>
          </>
        ) : (
          <p className="auth-description">
            Check your inbox for a password reset link. If you don't see it, check your spam folder.
          </p>
        )}
        <div className="login-prompt">
          <p>Remember your password?</p>
          <Link to="/login" className="login-button">Back to login</Link>
        </div>
      </form>
    </div>
  );
};

export default ForgotPassword;
